import { DASHBOARD_PDF_EXPORT_ROOT_ID } from "metabase/dashboard/constants";
import { useRegisterMetabotContextProvider } from "metabase/metabot";
import { getDashboardImage } from "metabase/visualizations/lib/image-exports";

import { getDashboard } from "../selectors";



export const useRegisterDashboardMetabotContext = () => {
  useRegisterMetabotContextProvider(async (state) => {
    const dashboard = getDashboard(state);
    if (!dashboard) {
      return {};
    }
   const dashboardSelector = `#${DASHBOARD_PDF_EXPORT_ROOT_ID}`;
   const imageBase64 = await getDashboardImage(dashboardSelector) ?? null;

    return {
      user_is_viewing: [
        { type: "dashboard", id: dashboard.id, dashboard_image: imageBase64},
      ],
    };
  }, []);
};
